import {
    Directive,
    Input,
} from '@angular/core';
import {
    MatAnchor,
    MatButton,
} from '@angular/material/button';
import { MatMenuItem } from '@angular/material/menu';

import { AuthorizeBaseDirective } from './authorize-base.directive';

@Directive({
    // tslint:disable-next-line: max-line-length
    selector: '[uiAuthorize],[uiAuthorizeDisable]:not([folderId]),[uiAuthorizeAny],[uiAuthorizeAnyDisable],[uiAuthorizeAll],[uiAuthorizeAllDisable]',
    providers: [MatButton, MatAnchor, MatMenuItem],
})
export class AuthorizeDirective extends AuthorizeBaseDirective {
    protected _isGranted(permission: string) {
        return this._appState.user.permissions.isGranted(permission);
    }

    @Input('uiAuthorize')
    public set permission(permission: string) {
        this._permission = permission;
    }

    @Input('uiAuthorizeDisable')
    public set permissionDisable(permission: string) {
        this._permissionDisable = permission;
    }

    @Input('uiAuthorizeAny')
    public set permissionAny(permissions: string[]) {
        this._permissionAny = permissions;
    }

    @Input('uiAuthorizeAnyDisable')
    public set permissionAnyDisable(permissions: string[]) {
        this._permissionAnyDisable = permissions;
    }

    @Input('uiAuthorizeAll')
    public set permissionAll(permissions: string[]) {
        this._permissionAll = permissions;
    }

    @Input('uiAuthorizeAllDisable')
    public set permissionAllDisable(permissions: string[]) {
        this._permissionAllDisable = permissions;
    }
}
